import { useDispatch } from 'react-redux';

export default function useStoreOrderDetailsId() {
    const dispatch = useDispatch();

    const executor = (order_details_id) => {
        // Save to Redux
        dispatch({
            type: 'SET_ORDER_DETAILS_ID',
            payload: order_details_id,
        });

        // Save to localStorage to persist across page refreshes
        localStorage.setItem('order_details_id', JSON.stringify(order_details_id));
    };

    return executor;
};